<template>
 <div class="mapIsLoading" v-if="isLoading || !isPolygonsLoaded">
   <TheSpinner />
 </div>

  <YandexMap @created="onInit" :settings="{
      apiKey: '8f9c05f8-5682-4fb4-9616-b81750722ba9',
      lang: 'ru_RU',
      version: '2.1',
  }" style="width: 100%; height: 100%; border-bottom-right-radius: 20px; border-top-right-radius: 20px; overflow: hidden" :zoom="zoom" :controls="['geolocationControl', 'zoomControl']" :coordinates="mapCenter" @click="selectPoint">

    <YandexMarker
      v-for="(poly, index) in polygon_list"
      :key="index"
      type="Polygon"
      :hint-content="'Доставка из: '+poly.address + ' - '+ poly.description"
      :marker-id="'poly'+index"
      :coordinates="formatPoly(poly.polygons)"
      :marker-fill="{color: poly.color}"
      :options="{
          fillColor: poly.color,
          strokeWidth: 0,
        }"
      @click="handlePolygonClick"
    />

    <YandexMarker v-if="coordinates" :marker-id="'dot1'" :options="{

      iconLayout: 'default#image',
       iconImageHref: '/assets/img/point_map.svg',
        iconImageSize: [32, 32],
         iconImageOffset: [-16, -32]
    }"
                   :coordinates="coordinates"></YandexMarker>

  </YandexMap>


</template>

<script>

import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import ShippingSource from "@/api/ShippingSource.js";
import TheSpinner from "@/components/TheSpinner.vue";
import { defineAsyncComponent } from 'vue'

const FALLBACK_CENTER = [45.035470, 38.975313]; // Краснодар — только если нет ни ресторана, ни точек самовывоза

export default {
  name: 'TheFlatMap',
  components: {
    TheSpinner,
    YandexMap: defineAsyncComponent(() => (
      typeof window === 'undefined' ? Promise.resolve(null) : import('vue-yandex-maps').then(module => module.YandexMap)
    )),
    YandexMarker: defineAsyncComponent(() => (
      typeof window === 'undefined' ? Promise.resolve(null) : import('vue-yandex-maps').then(module => module.YandexMarker)
    )),
  },
  data() {
    return {
      coordinates: null,
      isLoading: true,
    }
  },
  computed: {
    ...mapGetters({
      pickupList: 'shipping/pickupList'
    }),
    ...mapState({
      'isShippingLoading': state => state.shipping.isLoader,
      'isPolygonsLoaded': state => state.shipping.isPolygonsLoaded,
      'polygons': state => state.shipping.polygons,
      'allPolygons': state => state.shipping.allPolygons,
      'shipping': state => state.shipping.shipping,
      'currentCity': state => state.city.currentCity,
    }),
    polygon_list(){
      if(!this.showPolygons){
        return []
      }

      const list = this.showAllPolygons ? this.allPolygons : this.polygons;
      return list?.filter(item => item?.polygons?.length > 0) || [];
    },
    mapCenter() {
      return this.coordinates ?? FALLBACK_CENTER;
    }
  },
  watch: {
    coordinatesProps() {
      this.coordinates = this.coordinatesProps;
    }
  },
  async created() {
    this.loadPolygonsList();
    this.initCoordinates();
  },
  props: {
    coordinatesProps: {
      default: null
    },
    zoom: {
      default: 13
    },
    showPolygons: {
      default: false
    },
    showAllPolygons: {
      default: false
    },
    enableSelect: {
      default: true
    },
  },
  methods: {
    ...mapActions({
      loadPolygonsList: 'shipping/loadPolygonsList',
    }),

    formatPoly(data) {
      const formattedData = [];
      if (!data || !data.length) return [formattedData];

      data.forEach(point => {
        formattedData.push([point.lat, point.lon]);
      });

      formattedData.push([data[0].lat, data[0].lon]);

      return [formattedData];
    },
    onInit(){
      this.isLoading = false;
    },
    ...mapMutations({
      'setShippingLoader':'shipping/setLoader'
    }),
    async selectPoint(event) {

      if(!this.enableSelect){
        return;
      }

      if(this.isShippingLoading){
        return;
      }
      if(event.get('coords').length !== 2){
        return;
      }
      await this.$API.manager.getSource(ShippingSource).geolocate({
        'store_id': this.currentCity?.store_id,
        'lat': event.get('coords')[0],
        'lon': event.get('coords')[1],
      }).then((response) => {
        this.$emit('selectAddressFromSuggestion', response)
      }).catch((errorData) => {
        if(errorData?.response?.data?.error){
          this.$toast.open({
            message: errorData?.response?.data?.error,
            type: 'error',
          });
        }
      })
    },
    initCoordinates() {
      let institution = null;
      if (this.shipping?.institution) {
        institution = this.shipping?.institution;
      } else {
        institution = this.pickupList[0];
      }
      if(institution?.lat) {
        this.coordinates = [parseFloat(institution.lat), parseFloat(institution.lon)];
      }
    },

    handlePolygonClick(event) {
      if (event && typeof event.get === 'function') {
        const coords = event.get('coords')

        if (Array.isArray(coords) && coords.length === 2) {
          this.selectPoint({
            get: (key) => {
              if (key === 'coords') {
                  return coords
              }

              return undefined
            }
          })
        }
      }
    }
  }
}
</script>

